import AxiosClient from "../../../services/axios.services";

class CalendarEmployeeServices {
  getCalendarUserEvents = params =>
    AxiosClient.get("/api/app/Tiempos_empleado_planificacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
   getCalendarHolidays = () =>
    AxiosClient.get("/api/app/head_clima_feriados/", {
      headers: { "Content-Type": "application/json" }
   });
  getCalendarUserEvent = id => AxiosClient.get(`/api/app/Tiempos_empleado_planificacion/${id}/`);
  createCalendarUserEvent = data => AxiosClient.post("/api/app/Tiempos_empleado_planificacion/", data);
  updateCalendarUserEvent = (id, data) => AxiosClient.put(`/api/app/Tiempos_empleado_planificacion/${id}/`, data);
  deleteCalendarUserEvent = id => AxiosClient.delete(`/api/app/Tiempos_empleado_planificacion/${id}/`);
}

export default new CalendarEmployeeServices();